import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'toggleButton', 'icon', 'nav'];
  // Bootstrap's lg, which the v5 nav's d-lg-* utilities use. The v6 nav flips
  // wider and passes its own value.
  static values = { desktopMinWidth: { type: Number, default: 992 } };
  // Opt-in, so only the nav that declares it locks the page. Without a lock, a
  // drag on a non-scrolling part of the open drawer chains to the document; on
  // iOS that judders the fixed drawer and then latches the gesture away from it.
  static classes = ['scrollLock'];

  connect() {
    // Bind once: the old code removed a different bound function than it added,
    // so every connect leaked a listener.
    this.abortController = new AbortController();
    window.addEventListener('resize', this.resetMenu.bind(this), {
      signal: this.abortController.signal,
    });
  }

  disconnect() {
    this.abortController?.abort();
    this.lockScroll(false);
  }

  toggle() {
    const isHidden = this.menuTarget.classList.toggle('visually-hidden');

    if (isHidden) {
      this.iconTarget.classList.remove('close');
      this.iconTarget.classList.add('hamburger');
    } else {
      this.iconTarget.classList.remove('hamburger');
      this.iconTarget.classList.add('close');
    }

    this.lockScroll(!isHidden);
  }

  resetMenu() {
    if (window.innerWidth >= this.desktopMinWidthValue) {
      this.menuTarget.classList.add('visually-hidden');
      this.iconTarget.classList.remove('close');
      this.iconTarget.classList.add('hamburger');
      this.lockScroll(false);
    }
  }

  lockScroll(locked) {
    if (!this.hasScrollLockClass) return;

    document.body.classList.toggle(this.scrollLockClass, locked);
  }
}
